"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('anti-corrosion', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 41.9958C37.3333 42.0986 44 41.0071 44 38.7213C44 35.2926 28.4142 18.0024 24 18.0024C19.5858 18.0024 4 35.6508 4 38.7213C4 40.7683 10.6667 41.8598 24 41.9958Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M21.0598 29.6611L17.4401 34.0001",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M24.5 11C25.8807 11 27 9.88071 27 8.5C27 7.11929 25.8807 6 24.5 6C23.1193 6 22 7.11929 22 8.5C22 9.88071 23.1193 11 24.5 11Z",
    fill: props.outStrokeColor
  }), _react.default.createElement("path", {
    d: "M34 16C35.1046 16 36 15.1046 36 14C36 12.8954 35.1046 12 34 12C32.8954 12 32 12.8954 32 14C32 15.1046 32.8954 16 34 16Z",
    fill: props.outStrokeColor
  }), _react.default.createElement("path", {
    d: "M12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z",
    fill: props.outStrokeColor
  }), _react.default.createElement("path", {
    d: "M17.5 15C18.3284 15 19 14.3284 19 13.5C19 12.6716 18.3284 12 17.5 12C16.6716 12 16 12.6716 16 13.5C16 14.3284 16.6716 15 17.5 15Z",
    fill: props.outStrokeColor
  }));
});

exports.default = _default;